module.exports = __webpack_public_path__ + "img/chokorin4.56ffa458.png";